import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    fakeGet: function (delay) {
        var url = `https://reqres.in/api/users?delay=${delay}`;
        return BzbsApi.connectBzbsGet(url, null);
    },
    fakeGetError: function () {
        var url = this.config().bzbsUrl + "/api/auth/otp";
        return BzbsApi.connectBzbsGet(url, null);
    },
    fakeGetBackGround: function (delay) {
        var url = `https://reqres.in/api/users?delay=${delay}`;
        return BzbsApi.connectBzbsBackgroundGet(url);
    }
}